module.exports = __webpack_public_path__ + "img/beach@3x.aa88a23c.png";